@use "../../styles/breakpoint.module.scss" as *;

.filterChipsWrapper {
    @media ($below-mobile) {
        display: none;
    }
}

.chipList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--spacer-8) var(--spacer-16);
}

.chip {
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--spacer-16);
    padding: var(--spacer-4) var(--spacer-8);
    background: var(--gray-900);
    color: var(--white);
    font: var(--font-p-12);
    transition: background-color 0.2s;

    &:hover {
        background: var(--gray-700);
    }
}

.chipClose {
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
    }
}

.chipX {
    width: var(--spacer-12);
    height: var(--spacer-12);
    fill: currentColor;
}

.chipsClearAll {
    font: var(--font-text-link-14);
    text-decoration: underline;
}
